<template>
  <div
    class="International-trade internationalTradeRussiaEconRev mb-32"
    :class="{ notForTecRussiaTab: notForTecRussiaTab }"
  >
    <div class="International-trade__switchblock d-flex justify-content-between mb-22">
      <p class="economicsTypeTitle mb-0">Торгово-экономическое сотрудничество с Россией</p>
      <RedesignedSwitchComponent @switchHandler="switchHand($event)" />
      <div class="economics-period">
        <p class="fs14 gray">Источник: {{ isProductMode ? 'ФТС России' : 'Банк России' }}</p>
        <div class="economics-period__select">
          <SelectMultiComponent
            id="period"
            v-model="year"
            :options="yearList"
            classSelect="multiselect--green multiselect--hidden-clear"
            @select="yearChanged"
          />
        </div>

        <div v-if="!isProductMode" class="economics-period__select">
          <SelectMultiComponent
            id="quartal"
            v-model="quartal"
            :options="quartals"
            placeholder="Квартал"
            classSelect="multiselect--green"
            @select="loadDataQuartal"
          />
        </div>
      </div>
    </div>

    <template v-if="!currentSummary">
      <p>Загрузка данных...</p>
    </template>

    <template v-if="currentSummary">
      <TradeIndicatorsList class="indicators__list" justifyContent="start">
        <TradeIndicator
          :name="isProductMode ? 'Товарооборот' : 'Оборот услуг'"
          :divider="divider"
          unit="млн $"
          :currentValue="currentSummary[indicatorValue.TOTAL_VALUE]"
          :previousPercent="currentSummary[indicatorPreviousPercentValue.TOTAL_VALUE]"
          @click="
            resolveSelectTab({
              isCondition: turnoverMoreInfo,
              id: 1,
              label: isProductMode ? 'Товарооборот' : 'Оборот услуг',
            })
          "
          :isSelected="tabId === 1"
        />
        <TradeIndicator
          name="Экспорт"
          :divider="divider"
          unit="млн $"
          :currentValue="currentSummary[indicatorValue.EXPORT_VALUE]"
          :previousPercent="currentSummary[indicatorPreviousPercentValue.EXPORT_VALUE]"
          @click="
            resolveSelectTab({
              isCondition: exportMoreInfo,
              id: 2,
              label: 'Экспорт',
            })
          "
          :isSelected="tabId === 2"
        />
        <TradeIndicator
          name="Импорт"
          :divider="divider"
          unit="млн $"
          :currentValue="currentSummary[indicatorValue.IMPORT_VALUE]"
          :previousPercent="currentSummary[indicatorPreviousPercentValue.IMPORT_VALUE]"
          @click="
            resolveSelectTab({
              isCondition: importMoreInfo,
              id: 3,
              label: 'Импорт',
            })
          "
          :isSelected="tabId === 3"
        />
        <TradeIndicator
          v-if="isProductMode === true"
          name="ННЭ"
          :divider="divider"
          unit="млн $"
          :currentValue="currentSummary[indicatorValue.EXPORT_NON_ENERGY_VALUE]"
          :previousPercent="currentSummary[indicatorPreviousPercentValue.EXPORT_NON_ENERGY_VALUE]"
          @click="
            resolveSelectTab({
              isCondition: exportNonEnergyMoreInfo,
              id: 4,
              label: 'Несырьевой',
            })
          "
          :isSelected="tabId === 4"
        />
        <TradeIndicator
          name="Сальдо"
          :divider="divider"
          unit="млн $"
          :currentValue="currentSummary[indicatorValue.BALANCE]"
          :previousPercent="currentSummary[indicatorPreviousPercentValue.BALANCE]"
          :previousValue="currentSummary[indicatorPreviousValue.BALANCE]"
          class="indicators__itemCustom"
          @click="
            resolveSelectTab({
              isCondition: balanceMoreInfo,
              id: 5,
              label: 'Сальдо',
            })
          "
          :isSelected="tabId === 5"
        />
      </TradeIndicatorsList>
    </template>

    <template v-if="tabId && graphByYear">
      <div class="switch-wrapper my-5">
        <RedesignedSwitchComponent
          :checked="switchRows.tradingGraph"
          textTrue="Диаграмма"
          textFalse="Таблица"
          @switchHandler="switchRows.tradingGraph = !switchRows.tradingGraph"
        />
        <h2>
          <template v-if="isProductMode">Торговля товарами</template><template v-else>Торговля услугами</template>,
          {{ dividerLabel }} $ США
        </h2>
      </div>
      <div v-if="switchRows.tradingGraph && (tabId === 1 || tabId === 2 || tabId === 3 || tabId === 5)">
        <EChartsLine
          :xData="getForeignTradeXAxis"
          :series="getForeignTradeSeries"
          :tooltipPostfix="getForeignTradeValuePostfix"
          :key="graphKey"
        />
      </div>
      <div v-if="switchRows.tradingGraph && tabId === 4">
        <EChartsLine
          :xData="graphByYear.years"
          :yData="graphByYear.data[4]"
          lineName="Абсолютное значение"
          lineColor="#01A39D"
          :tooltipPostfix="getForeignTradeValuePostfix"
        />
      </div>
      <div class="table-container js-table-arrow" v-if="!switchRows.tradingGraph">
        <table class="stockTable">
          <thead>
            <tr>
              <th style="font-size: 14px">Год</th>
              <th style="font-size: 14px">
                {{ isProductMode ? 'Товарооборот' : 'Оборот услуг' }}
              </th>
              <th style="font-size: 14px">Экспорт</th>
              <th style="font-size: 14px">Импорт</th>
              <th style="font-size: 14px">Сальдо</th>
              <th v-if="isProductMode" style="font-size: 14px">ННЭ</th>
            </tr>
          </thead>
          <tbody v-if="tableData">
            <tr v-for="(item, index) in tableData" :key="index">
              <td class="font-weight-bold">{{ item.year }}</td>
              <td class="font-weight-bold">
                {{ formatNumber(item.total / (isProductMode ? million : 1000)) }}
              </td>
              <td class="font-weight-bold">
                {{ formatNumber(item.export / (isProductMode ? million : 1000)) }}
              </td>
              <td class="font-weight-bold">
                {{ formatNumber(item.import / (isProductMode ? million : 1000)) }}
              </td>
              <td class="font-weight-bold">
                {{ formatNumber(item.balance / (isProductMode ? million : 1000)) }}
              </td>
              <td v-if="isProductMode" class="font-weight-bold">
                {{ formatNumber(item.nonEnergy / (isProductMode ? million : 1000)) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="isProductMode">
      <!-- Товарная структура экспорта -->
      <div v-if="tabId && tabId !== 4 && tabId != 3 && currentSummary && currentSummary.topExportCode2?.length > 0">
        <div class="switch-wrapper my-5">
          <RedesignedSwitchComponent
            textTrue="Диаграмма"
            textFalse="Таблица"
            @switchHandler="switchRows.tovarnayaStructureExport = !switchRows.tovarnayaStructureExport"
          />
          <h2>Товарная структура экспорта</h2>
        </div>
        <!-- Диаграмма -->
        <template v-if="switchRows.tovarnayaStructureExport">
          <!-- <h2 class="my-5">Товарная структура экспорта</h2> -->
          <template v-if="currentSummary">
            <EChartsHorizontalBar
              :showTooltip="false"
              :valueFractionDigits="0"
              :labels="currentSummary.topExportCode2.map((item) => item.title)"
              :dataset="
                getPeriodGroupsDataset(
                  currentSummary.topExportCode2,
                  'Текущий период, млн $',
                  'Прошедший период, млн $',
                )
              "
            />
          </template>
        </template>
        <!-- Таблица -->
        <template v-else>
          <!-- <h2 class="my-5" v-if="currentSummary">
            Товарная структура экспорта (таблица)
          </h2> -->
          <InternationalTradeExportTable
            name="Экспорт"
            :currentSummary="currentSummary"
            dividerLabel="тыс $"
            exportGroups="exportCode2TotalCurrent"
            exportGroupsPrevious="exportCode2TotalPrevious"
            topExportGroups="topExportCode2"
          />
        </template>
      </div>
      <!-- Товарная структура экспорта -->
      <div v-if="tabId === 4 && currentSummary && currentSummary.topExportNonEnergyCode2?.length > 0">
        <div class="switch-wrapper my-5">
          <RedesignedSwitchComponent
            textTrue="Диаграмма"
            textFalse="Таблица"
            @switchHandler="switchRows.tovarnayaStructureExportSecond = !switchRows.tovarnayaStructureExportSecond"
          />
          <h2>Товарная структура экспорта</h2>
        </div>
        <!-- Диаграмма -->
        <template v-if="switchRows.tovarnayaStructureExportSecond">
          <!-- <h2 class="my-5">Товарная структура экспорта</h2> -->
          <template v-if="currentSummary">
            <EChartsHorizontalBar
              :showTooltip="false"
              :valueFractionDigits="0"
              :labels="currentSummary.topExportNonEnergyCode2.map((item) => item.title)"
              :dataset="
                getPeriodGroupsDataset(currentSummary.topExportNonEnergyCode2, 'Текущий период', 'Прошедший период')
              "
            />
          </template>
        </template>
        <!-- Таблица -->
        <template v-else>
          <!-- <h2 class="my-5" v-if="currentSummary">
            Товарная структура экспорта (таблица)
          </h2> -->
          <InternationalTradeExportTable
            name="Импорт"
            :currentSummary="currentSummary"
            dividerLabel=""
            exportGroups="exportNonEnergyCode2TotalCurrent"
            exportGroupsPrevious="exportNonEnergyCode2TotalPrevious"
            topExportGroups="topExportNonEnergyCode2"
          />
        </template>
      </div>
      <!-- Товарная структура импорта -->
      <div v-if="tabId && tabId !== 4 && tabId != 2 && currentSummary && currentSummary.topImportCode2?.length > 0">
        <div class="switch-wrapper my-5">
          <RedesignedSwitchComponent
            textTrue="Диаграмма"
            textFalse="Таблица"
            @switchHandler="switchRows.tovarnayaStructureImport = !switchRows.tovarnayaStructureImport"
          />
          <h2>Товарная структура импорта</h2>
        </div>
        <!-- Диаграмма -->
        <template v-if="switchRows.tovarnayaStructureImport">
          <!-- <h2 class="my-5">Товарная структура импорта</h2> -->
          <template v-if="currentSummary">
            <EChartsHorizontalBar
              :showTooltip="false"
              :valueFractionDigits="0"
              :labels="currentSummary.topImportCode2.map((item) => item.title)"
              :dataset="
                getPeriodGroupsDataset(
                  currentSummary.topImportCode2,
                  'Текущий период, млн $',
                  'Прошедший период, млн $',
                )
              "
            />
          </template>
        </template>
        <!-- Таблица -->
        <template v-else>
          <!-- <h2 class="my-5" v-if="currentSummary">
            Товарная структура импорта (таблица)
          </h2> -->
          <InternationalTradeExportTable
            name="Импорт"
            :currentSummary="currentSummary"
            dividerLabel="тыс $"
            exportGroups="importCode2TotalCurrent"
            exportGroupsPrevious="importCode2TotalPrevious"
            topExportGroups="topImportCode2"
          />
        </template>
      </div>
      <!-- ТОП-5 ТОВАРОВ экспорта импорт -->
      <template v-if="tabId && tabId !== 4">
        <!-- ТОП-5 ТОВАРОВ экспорта -->
        <template v-if="currentSummary && currentSummary.topExportGroups?.length > 0 && tabId != 3">
          <div class="switch-wrapper my-5">
            <RedesignedSwitchComponent
              textTrue="Диаграмма"
              textFalse="Таблица"
              @switchHandler="switchRows.topTovariExport = !switchRows.topTovariExport"
            />
            <h2>Топ-5 товаров экспорта</h2>
          </div>
          <!-- Диаграмма -->
          <div v-if="switchRows.topTovariExport">
            <!-- <h2 class="my-5">ТОП-5 ТОВАРОВ экспорта</h2> -->
            <EChartsHorizontalBar
              :showTooltip="false"
              :valueFractionDigits="2"
              :labels="currentSummary.topExportGroups.map((item) => item.title)"
              :dataset="
                getPeriodGroupsDataset(
                  currentSummary.topExportGroups,
                  'Текущий период тыс $',
                  'Прошедший период тыс $',
                  { divider: 1000, fractionDigits: 2 },
                )
              "
            />
          </div>
          <!-- Таблица -->
          <div v-else class="mt-5">
            <!-- <h2 class="my-5" v-if="currentSummary">
              ТОП-5 ТОВАРОВ (таблица)
            </h2> -->
            <InternationalTradeExportTable
              name="Экспорт"
              :currentSummary="currentSummary"
              dividerLabel="тыс $"
              exportGroups="exportGroupsTotalCurrent"
              exportGroupsPrevious="exportGroupsTotalPrevious"
              topExportGroups="topExportGroups"
            />
          </div>
        </template>
        <!-- ТОП-5 ТОВАРОВ импорта -->
        <template v-if="currentSummary && currentSummary.topImportGroups?.length > 0 && tabId != 2">
          <div class="switch-wrapper my-5">
            <RedesignedSwitchComponent
              textTrue="Диаграмма"
              textFalse="Таблица"
              @switchHandler="switchRows.topTovariImport = !switchRows.topTovariImport"
            />
            <h2>Топ-5 товаров импорта</h2>
          </div>
          <!-- Диаграмма -->
          <div v-if="switchRows.topTovariImport">
            <!-- <h2 class="my-5">ТОП-5 ТОВАРОВ импорта</h2> -->
            <EChartsHorizontalBar
              :showTooltip="false"
              :valueFractionDigits="0"
              :labels="currentSummary.topImportGroups.map((item) => item.title)"
              :dataset="
                getPeriodGroupsDataset(currentSummary.topImportGroups, 'Текущий период тыс $', 'Прошедший период тыс $')
              "
            />
          </div>
          <!-- Таблица -->
          <div v-else class="mt-5">
            <!-- <h2 class="my-5" v-if="currentSummary">
              ТОП-5 ТОВАРОВ (таблица)
            </h2> -->
            <InternationalTradeExportTable
              name="Импорт"
              :currentSummary="currentSummary"
              dividerLabel="тыс $"
              exportGroups="importGroupsTotalCurrent"
              exportGroupsPrevious="importGroupsTotalPrevious"
              topExportGroups="topImportGroups"
            />
          </div>
        </template>
      </template>
      <!-- ТОП-5 ТОВАРОВ экспорта снова -->
      <template v-if="tabId === 4 && currentSummary && currentSummary.topExportNonEnergyGroups?.length > 0">
        <div class="switch-wrapper my-5">
          <RedesignedSwitchComponent
            textTrue="Диаграмма"
            textFalse="Таблица"
            @switchHandler="switchRows.topTovariExportSecond = !switchRows.topTovariExportSecond"
          />
          <h2>Топ-5 товаров экспорта</h2>
        </div>
        <div v-if="switchRows.topTovariExportSecond">
          <!-- <h2 class="my-5">ТОП-5 ТОВАРОВ экспорта</h2> -->
          <EChartsHorizontalBar
            :showTooltip="false"
            :valueFractionDigits="2"
            :labels="currentSummary.topExportNonEnergyGroups.map((item) => item.title)"
            :dataset="
              getPeriodGroupsDataset(currentSummary.topExportNonEnergyGroups, 'Текущий период', 'Прошедший период', {
                divider: 1000,
                fractionDigits: 2,
              })
            "
          />
        </div>
        <div v-else class="mt-5">
          <!-- <h2 class="my-5" v-if="currentSummary">
            ТОП-5 ТОВАРОВ (таблица)
          </h2> -->
          <InternationalTradeExportTable
            name="Экспорт"
            :currentSummary="currentSummary"
            dividerLabel=""
            exportGroups="exportNonEnergyGroupsTotalCurrent"
            exportGroupsPrevious="exportNonEnergyGroupsTotalPrevious"
            topExportGroups="topExportNonEnergyGroups"
          />
        </div>
      </template>
    </template>

    <div class="mt-5" v-if="!isProductMode && currentSummary && currentSummary.topImportGroups?.length > 0">
      <SectionTitle text="Туризм" class="mb-3" />
      <EChartsVerticalBar
        formatLabel=" тыс чел"
        :formatValueFunction="formatBarChartValue"
        :labels="currentSummary.topImportGroups.map((item) => item.title)"
        :dataset="
          getPeriodGroupsDataset(
            currentSummary.topImportGroups,
            'Выезд российских граждан в страну, тыс чел',
            'Въезд иностранных граждан в Российскую Федерацию, тыс чел',
            { divider: 1, currentKey: 'previousValue', previousKey: 'currentValue' },
          )
        "
      />
    </div>
  </div>
</template>

<script>
  import RedesignedSwitchComponent from '@/common/components/redesigned/RedesignedSwitchComponent.vue';
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import text from '@/common/mixins/text';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import { DIVIDER_LABEL, IndicatorPreviousValue } from '../../utils/constants';
  import TradeIndicator from './indicators/TradeIndicator.vue';
  import TradeIndicatorsList from './indicators/TradeIndicatorsList.vue';
  import InternationalTradeExportTable from './InternationalTradeExportTable.vue';
  import InternationalTradeMixin from './mixin/InternationalTradeMixin';
  import InternationalTradeRussiaMixin from './mixin/InternationalTradeRussiaMixin';

  export default {
    name: 'InternationalTradeRussiaEconRev',
    mixins: [text, InternationalTradeMixin, InternationalTradeRussiaMixin],
    components: {
      EChartsLine,
      EChartsHorizontalBar,
      EChartsVerticalBar,
      RedesignedSwitchComponent,
      InternationalTradeExportTable,
      TradeIndicator,
      TradeIndicatorsList,
      SelectMultiComponent,
      SectionTitle,
    },
    emits: ['yearChanged'],
    data() {
      return {
        year: null,
        isProductMode: true,
        tabId: null,
        label: null,
        tableData: null,

        turnoverMoreInfo: true,
        exportMoreInfo: true,
        importMoreInfo: true,
        exportNonEnergyMoreInfo: true,
        balanceMoreInfo: true,

        divider: Constants.MILLION,
        dividerLabel: DIVIDER_LABEL,
        indicatorValue: Constants.indicator.value,
        indicatorPreviousPercentValue: Constants.indicator.previousPercentValue,
        indicatorPreviousValue: IndicatorPreviousValue,
        million: Constants.MILLION,

        switchRows: {
          tovarnayaStructureExport: true,
          tovarnayaStructureExportSecond: true,
          tovarnayaStructureImport: true,
          topTovariExport: true,
          topTovariImport: true,
          topTovariExportSecond: true,
          tradingGraph: false,
        },
      };
    },
    created() {
      this.loadIndicatorVisibility();
      this.loadYearList(true, true);
    },
    methods: {
      loadData() {
        this.loadRussiaForeignTradeData(() => {
          this.tableData = this.summary.summary.valuesByYears.map((x) => ({
            year: x.year,
            total: x.totalValue,
            export: x.exportValue,
            import: x.importValue,
            balance: x.balance,
            nonEnergy: x.exportNonEnergyValue,
          }));
        });
      },
      yearChanged() {
        this.loadData();
        if (!this.isProductMode) {
          this.loadQuartals();
        }
      },
      /**@public
       * Используется в миксине InternationalTradeMixin
       */
      selectTab(id, label) {
        if (id != this.tabId) {
          this.tabId = id;
          this.label = label;
        } else {
          // при повторном клике - сворачивание
          this.tabId = null;
          this.label = null;
        }
      },
      getPeriodGroupsDataset(groups, currentLabel, previousLabel, options = {}) {
        const {
          divider = this.divider,
          fractionDigits = 0,
          currentKey = 'currentValue',
          previousKey = 'previousValue',
        } = options;

        return [
          {
            label: currentLabel,
            data: groups.map((item) => Number((item[currentKey] / divider).toFixed(fractionDigits))),
            color: '#04b1e0',
          },
          {
            label: previousLabel,
            data: groups.map((item) => Number((item[previousKey] / divider).toFixed(fractionDigits))),
            color: '#00C6A2',
          },
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './src/assets/theme/default/colors';
  @import './styles/InternationalTradeRussiaEconRev.scss';
  @import '../../styles/countryAnalyticsMultiselect.scss';

  .notForTecRussiaTab {
    h2,
    .indicators__item .btn-default {
      display: none !important;
    }
    .indicators__wrapper {
      margin-bottom: 17px;
    }
  }
</style>
